import { render, staticRenderFns } from "./taxReport.vue?vue&type=template&id=30c07582&scoped=true"
import script from "./taxReport.vue?vue&type=script&lang=js"
export * from "./taxReport.vue?vue&type=script&lang=js"
import style0 from "./taxReport.vue?vue&type=style&index=0&id=30c07582&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c07582",
  null
  
)

export default component.exports